import styled from '@emotion/styled';
import { StyledTextProps } from '@silvertours/front-shared';

const IconGridContainer = styled.div`
  height: 100%;
  display: flex;
  width: 350px;
  gap: ${({ theme }) => theme.spacing[40]};
  flex-wrap: wrap;

  ${({ theme }) => theme.mq('xl')} {
    width: 100%;
    flex-wrap: nowrap;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 122px;
`;

const Label = styled.div<StyledTextProps>`
  margin: ${({ theme }) => theme.spacing[10]};
  justify-self: center;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: ${({ theme }) => theme.fontSize.sm.size};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  line-height: ${({ theme }) => theme.fontSize.sm.lineHeight};
`;

export { IconWrapper, IconGridContainer, Label };
